import { render } from "./addDialog.vue?vue&type=template&id=bb9d470e&scoped=true"
import script from "./addDialog.vue?vue&type=script&lang=js"
export * from "./addDialog.vue?vue&type=script&lang=js"

import "./addDialog.vue?vue&type=style&index=0&id=bb9d470e&lang=css"
import "./addDialog.vue?vue&type=style&index=1&id=bb9d470e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb9d470e"]])

export default __exports__